import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.tel))]),(_vm.tel)?_c(VIcon,{attrs:{"color":"blue","small":""},on:{"click":_vm.call}},[_vm._v("call")]):_vm._e(),(_vm.tel)?_c(VIcon,{attrs:{"small":"","color":"green"},on:{"click":_vm.whatsapp}},[_vm._v("mdi-whatsapp")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }